module.exports = __webpack_public_path__ + "static/media/epillax-2.2b1dfdb8.jpg";